export const CATEGORY_HIERARCHY = {
  "Alimentos": {
    name: "Alimentos y Bebidas",
    subcategories: {
      "Carnes Rojas": [
        "Carne Vacuna",
        "Carne de Cordero",
        "Achuras",
        "Hamburguesas"
      ],
      "Carnes de Cerdo": [
        "Cortes Frescos",
        "Embutidos",
        "Fiambres",
        "Panceta"
      ],
      "Pescados y Mariscos": [
        "Pescados Frescos",
        "Pescados Congelados",
        "Mariscos",
        "Conservas de Pescado"
      ],
      "Aves": [
        "Pollo",
        "Pavo",
        "Pato",
        "Menudencias"
      ],
      "Lácteos y Huevos": [
        "Leche",
        "Quesos",
        "Yogurt",
        "Manteca",
        "Crema",
        "Huevos"
      ],
      "Frutas y Verduras": [
        "Frutas Frescas",
        "Verduras Frescas",
        "Frutas Secas",
        "Verduras Congeladas"
      ],
      "Panadería": [
        "Pan Fresco",
        "Facturas",
        "Galletitas",
        "Panificados"
      ],
      "Bebidas Alcohólicas": [
        "Vinos",
        "Cervezas",
        "Espumantes",
        "Licores",
        "Whisky",
        "Vodka",
        "Gin",
        "Ron"
      ],
      "Bebidas Sin Alcohol": [
        "Gaseosas",
        "Aguas",
        "Jugos",
        "Energizantes",
        "Bebidas Deportivas",
      ],
      "Infusiones": [
        "Yerba Mate",
        "Infusiones",
        "Mates",
        "Café"
      ],
      "Alimentos Secos": [
        "Arroz",
        "Pasta",
        "Legumbres",
        "Cereales",
        "Harinas"
      ],
      "Congelados": [
        "Comidas Preparadas",
        "Vegetales",
        "Helados",
        "Postres"
      ],
      "Conservas": [
        "Enlatados",
        "Salsas",
        "Encurtidos",
        "Mermeladas"
      ],
      "Aceites y Vinagres": [
        "Aceite de Oliva",
        "Aceite de Girasol",
        "Aceite de Maíz",
        "Aceite Vegetal",
        "Vinagre de Vino",
        "Vinagre Balsámico",
        "Vinagre de Manzana",
        "Aceto Balsámico"
      ],
      "Condimentos y Especias": [
        "Sal",
        "Pimienta",
        "Condimentos para Carnes",
        "Especias Enteras",
        "Especias Molidas",
        "Hierbas Aromáticas",
        "Ají Molido",
        "Pimentón"
      ],
      "Salsas y Aderezos": [
        "Mayonesa",
        "Mostaza",
        "Ketchup",
        "Salsa Golf",
        "Salsa de Soja",
        "Salsa Barbacoa",
        "Aderezos para Ensalada",
        "Chimichurri"
      ],
      "Snacks y Golosinas": [
        "Papas Fritas",
        "Maní",
        "Palitos Salados",
        "Chocolates",
        "Caramelos",
        "Galletitas Dulces",
        "Galletitas Saladas",
        "Chicles"
      ],
      "Desayuno y Merienda": [
        "Cereales",
        "Granola",
        "Mermeladas",
        "Dulce de Leche",
        "Miel",
        "Mantequilla de Maní",
        "Cacao en Polvo",
        "Avena"
      ],
      "Enlatados y Conservas": [
        "Atún",
        "Sardinas",
        "Caballa",
        "Arvejas",
        "Choclo",
        "Palmitos",
        "Champiñones",
        "Tomates"
      ]
    }
  },
  "Bazar": {
    name: "Bazar y Menaje",
    subcategories: {
      "Utensilios de Cocina": [
        "Destapadores",
        "Abrelatas",
        "Sacacorchos",
        "Molinillos",
        "Morteros",
        "Pinzas"
      ],
      "Accesorios de Bebidas": [
        "Cocteleras",
        "Moldes para Hielo",
        "Enfriadores de Piedra",
        "Enfriadores de Acero",
        "Hieleras",
        "Botellas"
      ],
      "Herramientas y Accesorios": [
        "Navajas",
        "Multiherramientas",
        "Llaveros",
        "Guantes de Látex",
        "Guantes de Nitrilo"
      ],
      "Artículos de Coctelería": [
        "Vasos Mezcladores",
        "Medidores",
        "Coladores",
        "Cucharas de Bar",
        "Picos Vertedores",
        "Accesorios de Coctelería"
      ]
    }
  },
  "Electrónica": {
    name: "Electrónica y Tecnología",
    subcategories: {
      "Televisores": [
        "Smart TV",
        "LED TV",
        "OLED TV",
        "Accesorios TV"
      ],
      "Celulares y Tablets": [
        "Celulares",
        "Tablets",
        "Accesorios Móviles",
        "Smartwatches"
      ],
      "Computadoras": [
        "Notebooks",
        "PC de Escritorio",
        "Monitores",
        "Impresoras",
        "Accesorios PC"
      ],
      "Electrodomésticos": [
        "Heladeras",
        "Lavarropas",
        "Lavavajillas",
        "Microondas",
        "Cafeteras",
        "Aires Acondicionados",
        "Aspiradoras",
        "Hornos",
        "Cocinas"
      ],
      "Fotografía": [
        "Cámaras Digitales",
        "Cámaras Profesionales",
        "Accesorios Fotografía",
        "Drones"
      ],
      "Almacenamiento": [
        "Pendrives USB",
        "Pendrives USB-C",
        "Tarjetas SD",
        "Tarjetas Micro SD",
        "Discos Externos"
      ],
      "Audio y Sonido": [
        "Auriculares",
        "Auriculares Vincha",
        "Manos Libres",
        "Parlantes",
        "Parlantes Bluetooth",
        "Home Theater",
        "Equipos de Música"
      ],
      "Accesorios Computación": [
        "Mouses",
        "Teclados",
        "Kits Teclado y Mouse",
        "Cables de Red",
        "Adaptadores",
        "Webcams"
      ],
      "Cables y Conectividad": [
        "Cables USB",
        "Cables HDMI",
        "Cables de Red",
        "Cables de Audio",
        "Adaptadores"
      ],
      "Cargadores y Energía": [
        "Cargadores USB",
        "Cargadores USB-C",
        "Cargadores Lightning",
        "Cargadores Inalámbricos",
        "Powerbanks"
      ],
      "Soportes y Montaje": [
        "Soportes para TV",
        "Soportes para Monitor",
        "Soportes para Celular",
        "Soportes para Tablet",
        "Brazos Articulados"
      ],
      "Seguridad y Vigilancia": [
        "Cámaras de Seguridad",
        "Sistemas de Vigilancia",
        "Sensores de Movimiento",
        "DVR",
        "Accesorios de Seguridad"
      ]
    }
  },
  "Hogar": {
    name: "Hogar y Muebles",
    subcategories: {
      "Muebles": [
        "Sillones y Sofás",
        "Mesas y Sillas",
        "Camas y Colchones",
        "Muebles de Cocina",
        "Muebles de Jardín",
        "Escritorios",
        "Bibliotecas y Estantes"
      ],
      "Decoración": [
        "Cuadros y Espejos",
        "Alfombras",
        "Cortinas",
        "Almohadones",
        "Velas y Aromas",
        "Plantas Artificiales",
        "Relojes"
      ],
      "Iluminación": [
        "Lámparas de Techo",
        "Lámparas de Pie",
        "Veladores",
        "Spots",
        "Tiras LED",
        "Bombitas",
        "Accesorios Iluminación"
      ],
      "Textiles del Hogar": [
        "Sábanas y Acolchados",
        "Toallas y Toallones",
        "Manteles",
        "Frazadas y Mantas",
        "Almohadas",
        "Cortinas de Baño"
      ],
      "Jardín y Exterior": [
        "Parrillas y Asadores",
        "Mesas y Sillas de Jardín",
        "Sombrillas y Gazebos",
        "Macetas y Jardineras",
        "Herramientas de Jardín",
        "Riego",
        "Piscinas"
      ],
      "Baño y Cocina": [
        "Muebles de Baño",
        "Organizadores",
        "Accesorios de Baño",
        "Cortinas de Baño",
        "Alfombras de Baño"
      ]
    }
  },
  "Indumentaria": {
    name: "Indumentaria y Calzado",
    subcategories: {
      "Ropa Hombre": [
        "Remeras y Chombas",
        "Pantalones",
        "Camisas",
        "Camperas y Abrigos",
        "Ropa Interior",
        "Ropa Deportiva",
        "Trajes"
      ],
      "Ropa Mujer": [
        "Remeras y Blusas",
        "Pantalones",
        "Vestidos",
        "Polleras",
        "Camperas y Abrigos",
        "Ropa Interior",
        "Ropa Deportiva"
      ],
      "Ropa Niños": [
        "Bebés",
        "Niños",
        "Niñas",
        "Ropa Interior",
        "Calzado Infantil",
        "Accesorios Niños"
      ],
      "Calzado": [
        "Zapatillas",
        "Zapatos",
        "Botas",
        "Sandalias",
        "Ojotas",
        "Pantuflas",
        "Calzado Deportivo"
      ],
      "Accesorios": [
        "Carteras y Bolsos",
        "Cinturones",
        "Billeteras",
        "Relojes",
        "Anteojos",
        "Gorros y Sombreros",
        "Bufandas y Guantes"
      ]
    }
  },
  "Construcción": {
    name: "Construcción y Materiales",
    subcategories: {
      "Cemento y Cal": [
        "Cemento Portland",
        "Cemento de Albañilería",
        "Cal Hidratada",
        "Cal Viva",
        "Yeso",
        "Adhesivos",
        "Pastinas"
      ],
      "Ladrillos y Bloques": [
        "Ladrillos Comunes",
        "Ladrillos Huecos",
        "Bloques de Hormigón",
        "Bloques de Cemento"
      ],
      "Arena y Piedras": [
        "Arena Fina",
        "Arena Gruesa",
        "Piedra Partida",
        "Canto Rodado"
      ],
      "Hormigón": [
        "Hormigón Elaborado",
        "Hormigón H17",
        "Hormigón H21",
        "Hormigón H25",
        "Hormigón H30"
      ],
      "Hierros y Mallas": [
        "Hierros Nervados",
        "Mallas Electrosoldadas",
        "Alambres",
        "Clavos"
      ],
      "Herramientas": [
        "Herramientas Eléctricas",
        "Herramientas Manuales",
        "Escaleras",
        "Carretillas",
        "Compresores",
        "Soldadoras",
        "Generadores"
      ],
      "Sanitarios": [
        "Inodoros",
        "Bachas",
        "Bañeras",
        "Griferías",
        "Accesorios Baño",
        "Tanques de Agua",
        "Bombas de Agua"
      ],
      "Pinturas": [
        "Látex",
        "Esmaltes",
        "Barnices",
        "Impermeabilizantes",
        "Pinceles y Rodillos",
        "Diluyentes",
        "Enduidos"
      ],
      "Electricidad": [
        "Cables",
        "Tableros",
        "Llaves y Tomas",
        "Iluminación",
        "Cajas y Gabinetes",
        "Térmicas y Disyuntores",
        "Medidores"
      ],
      "Plomería": [
        "Caños y Conexiones",
        "Tanques",
        "Bombas",
        "Termotanques",
        "Griferías",
        "Desagües",
        "Herramientas Plomería"
      ]
    }
  },
  "Automotor": {
    name: "Automotor y Repuestos",
    subcategories: {
      "Repuestos Autos": [
        "Motor",
        "Frenos",
        "Suspensión",
        "Transmisión",
        "Carrocería",
        "Electricidad",
        "Filtros"
      ],
      "Repuestos Motos": [
        "Motor",
        "Frenos",
        "Suspensión",
        "Transmisión",
        "Carrocería",
        "Electricidad",
        "Filtros"
      ],
      "Neumáticos": [
        "Neumáticos Auto",
        "Neumáticos Camioneta",
        "Neumáticos Moto",
        "Llantas",
        "Cámaras",
        "Accesorios Neumáticos"
      ],
      "Accesorios Vehiculares": [
        "Audio y Video Vehicular",
        "GPS Vehicular",
        "Iluminación Vehicular",
        "Alarmas",
        "Baterías", "Fundas y Tapizados",
      ],
      "Herramientas Automotor": [
        "Herramientas Especiales",
        "Diagnóstico",
        "Elevadores",
        "Compresores",
        "Soldadoras",
        "Lubricación"
      ],
      "Lubricantes": [
        "Aceites Motor",
        "Aceites Caja",
        "Líquido Frenos",
        "Refrigerantes",
        "Aditivos",
        "Grasas"
      ]
    }
  },
  "Textiles": {
    name: "Textiles y Telas",
    subcategories: {
      "Telas": [
        "Algodón",
        "Poliéster",
        "Seda",
        "Lana",
        "Lino",
        "Gabardina",
        "Jean",
        "Pana",
        "Terciopelo",
        "Lycra",
        "Raso",
        "Tul",
        "Polar"
      ],
      "Mercería": [
        "Hilos",
        "Agujas",
        "Botones",
        "Cierres",
        "Elásticos",
        "Cintas",
        "Apliques",
        "Encajes",
        "Entretelas"
      ],
      "Telas Especiales": [
        "Telas para Tapicería",
        "Telas Impermeables",
        "Telas Deportivas",
        "Telas para Cortinas",
        "Telas de Fantasía",
        "Telas para Disfraces",
        "Telas Térmicas"
      ],
      "Cueros y Sintéticos": [
        "Cuero Natural",
        "Cuero Ecológico",
        "Cuerina",
        "Gamuza",
        "Nobuck",
        "Charol"
      ],
      "Materiales de Costura": [
        "Máquinas de Coser",
        "Accesorios de Costura",
        "Patrones",
        "Tijeras y Cortadores",
        "Alfileres y Agujas",
        "Reglas y Medidores"
      ]
    }
  },
  "Papelería": {
    name: "Papelería y Oficina",
    subcategories: {
      "Papel": [
        "Resmas A4",
        "Resmas A3",
        "Resmas Oficio",
        "Papel Fotográfico",
        "Papel Térmico",
        "Papel Kraft",
        "Papel Autocopiativo"
      ],
      "Artículos de Escritura": [
        "Lápices",
        "Bolígrafos",
        "Marcadores",
        "Resaltadores",
        "Correctores",
        "Portaminas",
        "Tintas"
      ],
      "Material de Oficina": [
        "Carpetas",
        "Archivadores",
        "Clips y Broches",
        "Gomas de Borrar",
        "Sacapuntas",
        "Tijeras",
        "Pegamentos",
        "Cintas Adhesivas"
      ],
      "Cuadernos y Blocks": [
        "Cuadernos Escolares",
        "Blocks de Notas",
        "Agendas",
        "Libretas",
        "Blocks de Dibujo",
        "Hojas Sueltas"
      ],
      "Insumos de Impresión": [
        "Cartuchos de Tinta",
        "Toners",
        "Cintas de Impresora",
        "Papel Continuo",
        "Etiquetas Adhesivas"
      ],
      "Artículos de Dibujo": [
        "Lápices de Colores",
        "Crayones",
        "Acuarelas",
        "Pinceles",
        "Reglas y Escuadras",
        "Compases",
        "Tableros de Dibujo"
      ]
    }
  },
  "Industria": {
    name: "Industria y Manufactura",
    subcategories: {
      "Maquinaria Industrial": [
        "Máquinas CNC",
        "Tornos",
        "Fresadoras",
        "Prensas Industriales",
        "Compresores Industriales",
        "Soldadoras Industriales",
        "Hornos Industriales"
      ],
      "Equipamiento de Seguridad": [
        "EPP",
        "Señalización",
        "Detectores",
        "Extintores",
        "Sistemas de Alarma",
        "Ropa de Seguridad"
      ],
      "Insumos Industriales": [
        "Aceites Industriales",
        "Grasas Industriales",
        "Solventes",
        "Adhesivos Industriales",
        "Productos Químicos",
        "Gases Industriales"
      ],
      "Herramientas Industriales": [
        "Herramientas Neumáticas",
        "Herramientas Hidráulicas",
        "Herramientas de Corte",
        "Instrumentos de Medición",
        "Herramientas de Calibración"
      ]
    }
  },
  "Químicos": {
    name: "Químicos y Laboratorio",
    subcategories: {
      "Químicos Industriales": [
        "Ácidos",
        "Bases",
        "Solventes Químicos",
        "Catalizadores",
        "Reactivos",
        "Aditivos"
      ],
      "Equipamiento de Laboratorio": [
        "Instrumentos de Medición",
        "Equipos de Análisis",
        "Cristalería",
        "Almacenamiento",
        "Equipos de Seguridad"
      ],
      "Productos de Limpieza": [
        "Desinfectantes",
        "Detergentes",
        "Solventes de Limpieza",
        "Desengrasantes",
        "Sanitizantes"
      ]
    }
  },
  "Agricultura": {
    name: "Agricultura y Ganadería",
    subcategories: {
      "Insumos Agrícolas": [
        "Semillas",
        "Fertilizantes",
        "Agroquímicos",
        "Sustratos",
        "Sistemas de Riego",
      ],
      "Maquinaria Agrícola": [
        "Tractores",
        "Cosechadoras",
        "Sembradoras",
        "Fumigadoras",
        "Implementos Agrícolas"
      ],
      "Ganadería": [
        "Alimentos Balanceados",
        "Suplementos Animales",
        "Equipamiento Veterinario",
        "Cercas y Alambrados",
        "Bebederos y Comederos"
      ]
    }
  },
  "Embalajes": {
    name: "Embalajes y Logística",
    subcategories: {
      "Cajas y Contenedores": [
        "Cajas de Cartón",
        "Contenedores Plásticos",
        "Cajones de Madera",
        "Contenedores Metálicos",
        "Cajas Térmicas",
        "Films y Plásticos",
        "Cintas Adhesivas",
        "Etiquetas Industriales"
      ],
      "Material de Embalaje": [
        "Film Stretch",
        "Burbujas Plásticas",
        "Cintas de Embalaje",
        "Flejes",
        "Rellenos Protectores"
      ],
      "Equipamiento Logístico": [
        "Pallets",
        "Zunchos",
        "Carretillas",
        "Apiladoras",
        "Básculas"
      ]
    }
  },
  "Tabaquería": {
    name: "Tabaquería y Accesorios",
    subcategories: {
      "Tabaco": [
        "Tabaco para Armar",
        "Tabaco para Pipa",
        "Tabaco Saborizado",
        "Tabaco Importado",
        "Tabaco Nacional"
      ],
      "Cigarrillos y Cigarros": [
        "Cigarrillos",
        "Cigarros",
        "Habanos",
        "Blunts",
        "Wraps",
        "Hemps"
      ],
      "Papeles y Filtros": [
        "Papeles para Armar",
        "Filtros",
        "Conos Armados",
        "Tips",
        "Papelillos"
      ],
      "Equipos de Armado": [
        "Máquinas de Armar",
        "Armadores Automáticos",
        "Armadores Manuales",
        "Rellenadoras",
        "Tubos para Rellenar"
      ],
      "Accesorios de Fumador": [
        "Encendedores",
        "Ceniceros",
        "Pipas",
        "Picadores",
        "Bongs de Vidrio",
        "Bongs de Acrílico",
        "Narguiles"
      ],
      "Accesorios para Pipa": [
        "Pipas para Tabaco",
        "Limpiadores",
        "Estuches",
        "Portatabaco"
      ]
    }
  },
  "Bolsas": {
    name: "Bolsas y Embalajes",
    subcategories: {
      "Bolsas de Uso General": [
        "Bolsas de Arranque",
        "Bolsas Camiseta",
        "Bolsas Biodegradables",
        "Bolsas Alta Densidad",
        "Bolsas Baja Densidad"
      ],
      "Bolsas de Residuos": [
        "Bolsas de Consorcio",
        "Bolsas de Residuos Domésticos",
        "Bolsas Industriales",
        "Bolsas Reforzadas",
        "Bolsas Reciclables"
      ],
      "Separadores y Láminas": [
        "Separadores Folex",
        "Láminas en Rollo",
        "Láminas en Sobre",
        "Separadores por Medida",
        "Láminas Especiales"
      ]
    }
  },
  "Perfumería": {
    name: "Perfumería y Limpieza",
    subcategories: {
      "Cuidado Personal": [
        "Afeitadoras",
        "Filos de Afeitar",
        "Preservativos",
        "Desodorantes",
        "Jabones",
        "Pañuelos",
        "Curitas"
      ],
      "Limpieza e Higiene": [
        "Productos de Limpieza",
        "Desinfectantes",
        "Guantes de Látex",
        "Guantes de Nitrilo",
        "Artículos de Sanitización"
      ],
      "Farmacia": [
        "Alcohol",
        "Agua Oxigenada",
        "Algodón",
        "Gasas",
        "Productos de Botiquín"
      ],
      "Control de Plagas": [
        "Repelentes",
        "Insecticidas",
        "Raid",
        "Fuyi",
        "Off"
      ]
    }
  }
};

export const CATEGORY_QUALITIES = {
  "Vinos": {
    capacity: { type: "text", label: "Capacidad", format: "ml", required: true },
    type: { type: "select", label: "Varietal", options: ["Malbec", "Cabernet Sauvignon", "Syrah", "Chardonnay", "Torrontés", "Merlot"], required: true },
    alcohol: { type: "number", label: "Alcohol %", format: "%", required: true }
  },
  "Cervezas": {
    capacity: { type: "text", label: "Capacidad", format: "ml", required: true },
    type: { type: "select", label: "Tipo", options: ["Lager", "Ale", "IPA", "Stout", "Porter"], required: true },
    alcohol: { type: "number", label: "Alcohol %", format: "%", required: true }
  },
  "Smart TV": {
    resolution: { type: "select", label: "Resolución", options: ["1920x1080", "3840x2160", "7680x4320"], required: true },
    size: { type: "number", label: "Tamaño", format: '"', required: true },
    smart: { type: "select", label: "Sistema Operativo", options: ["Android TV", "WebOS", "Tizen", "Roku"], required: true }
  },
  "Monitores": {
    resolution: { type: "select", label: "Resolución", options: ["1920x1080", "2560x1440", "3840x2160"], required: true },
    refreshRate: { type: "select", label: "Tasa de Refresco", options: ["60Hz", "75Hz", "144Hz", "165Hz", "240Hz"], required: true },
    size: { type: "number", label: "Tamaño", format: '"', required: true },
    panel: { type: "select", label: "Tipo de Panel", options: ["IPS", "VA", "TN", "OLED"], required: true }
  },
  "Celulares": {
    storage: { type: "select", label: "Almacenamiento", options: ["64GB", "128GB", "256GB", "512GB"], required: true },
    ram: { type: "select", label: "Memoria RAM", options: ["4GB", "6GB", "8GB", "12GB"], required: true },
    screen: { type: "number", label: "Tamaño de Pantalla", format: '"', required: true },
    camera: { type: "text", label: "Cámara Principal", format: "MP", required: true }
  },
  "Máquinas CNC": {
    power: { type: "number", label: "Potencia", format: "kW", required: true },
    workArea: { type: "text", label: "Área de Trabajo", format: "mm", required: true },
    precision: { type: "text", label: "Precisión", format: "mm", required: true }
  },
  "Compresores Industriales": {
    power: { type: "number", label: "Potencia", format: "HP", required: true },
    capacity: { type: "number", label: "Capacidad", format: "L", required: true },
    pressure: { type: "number", label: "Presión Máxima", format: "bar", required: true }
  },
  "Ácidos": {
    concentration: { type: "number", label: "Concentración", format: "%", required: true },
    volume: { type: "number", label: "Volumen", format: "L", required: true },
    purity: { type: "number", label: "Pureza", format: "%", required: true }
  },
  "Solventes Químicos": {
    volume: { type: "number", label: "Volumen", format: "L", required: true },
    purity: { type: "number", label: "Pureza", format: "%", required: true },
    flashPoint: { type: "number", label: "Punto de Inflamación", format: "°C", required: true }
  },
  "Fertilizantes": {
    weight: { type: "number", label: "Peso", format: "kg", required: true },
    composition: { type: "text", label: "Composición NPK", required: true },
    type: { type: "select", label: "Tipo", options: ["Granulado", "Líquido", "Foliar"], required: true }
  },
  "Semillas": {
    weight: { type: "number", label: "Peso", format: "kg", required: true },
    variety: { type: "text", label: "Variedad", required: true },
    germinationRate: { type: "number", label: "Tasa de Germinación", format: "%", required: true }
  },
  "Film Stretch": {
    width: { type: "number", label: "Ancho", format: "mm", required: true },
    length: { type: "number", label: "Largo", format: "m", required: true },
    thickness: { type: "number", label: "Espesor", format: "µm", required: true }
  },
  "Cajas de Cartón": {
    length: { type: "number", label: "Largo", format: "mm", required: true },
    width: { type: "number", label: "Ancho", format: "mm", required: true },
    height: { type: "number", label: "Alto", format: "mm", required: true },
    resistance: { type: "text", label: "Resistencia", format: "kg", required: true }
  }
};

export const CATEGORY_IMAGES = {
  "Alimentos" : 'https://res.cloudinary.com/dzbc996mo/image/upload/w_400/q_auto/v1739502760/food_tinwhf_smkgoa.webp',
  "Celulares y Tablets" : "https://res.cloudinary.com/dzbc996mo/image/upload/w_400/q_auto/v1737519303/modelos-de-celulares-samsung_pfj3rw.png",
  "Electrónica" : "https://res.cloudinary.com/dzbc996mo/image/upload/w_400/q_auto/v1737519501/electronica_lck1g2.jpg",
  "Bebidas Alcohólicas" : "https://res.cloudinary.com/dzbc996mo/image/upload/w_400/q_auto/v1737520244/bebidasalco_chm0fk.jpg",
  "Papel" : "https://res.cloudinary.com/dzbc996mo/image/upload/w_400/q_auto/t_asd/v1744138532/resmas_dioybt.jpg",
}
export const getQualitiesForCategory = (category) => {
  if (CATEGORY_QUALITIES[category]) {
    return CATEGORY_QUALITIES[category];
  }

  for (const [mainCat, data] of Object.entries(CATEGORY_HIERARCHY)) {
    for (const [subCat, items] of Object.entries(data.subcategories)) {
      if (items.includes(category)) {
        return CATEGORY_QUALITIES[category] || CATEGORY_QUALITIES[subCat] || null;
      }
      if (subCat === category) {
        return CATEGORY_QUALITIES[category] || null;
      }
    }
  }

  return null;
}; 